import { api } from '@/lib/api'

export function deleteAccount(id: string) {
  return api.post(`/v1/me/wallets/${id}`, {})
}
